import { call, put, takeEvery } from 'redux-saga/effects'
import {
  GET_DEPARTMENTS,
  ADD_DEPARTMENTS,
  UPDATE_DEPARTMENTS,
  DELETE_DEPARTMENTS,
} from './actionTypes'
import {
  getDepartmentsSuccess,
  getDepartmentsFail,
  addDepartmentSuccess,
  addDepartmentFail,
  updateDepartmentSuccess,
  updateDepartmentFail,
  deleteDepartmentSuccess,
  deleteDepartmentFail,
  setDepartmentFieldErrors,
} from './actions'
import axiosInstance from 'pages/Utility/axiosInstance'
import toast from 'react-hot-toast'

// API calls
const fetchDepartmentsApi = () => axiosInstance.get('', { params: { sp: 'usp_GetDepartments' } })
const addDepartmentApi = (department) => axiosInstance.post('', department)
const updateDepartmentApi = (department) => axiosInstance.post('', department)
const deleteDepartmentApi = (id) => axiosInstance.post(``, { sp: 'usp_DeleteDepartment', departmentId: id })

// Sagas
function* getDepartmentsSaga() {
  try {
    const { data } = yield call(fetchDepartmentsApi)
    yield put(getDepartmentsSuccess(data))
  } catch (error) {
    yield put(getDepartmentsFail(error.response?.data || error.message))
  }
}

function* addDepartmentSaga(action) {
  try {
    const { data } = yield call(addDepartmentApi, action.payload)
    yield put(addDepartmentSuccess(data))
    toast.success('Department added successfully!')
    yield put({ type: GET_DEPARTMENTS })
  } catch (error) {
    if (error.response?.status === 400 && error.response?.data?.fieldErrors) {
      yield put(setDepartmentFieldErrors(error.response.data.fieldErrors))
    } else {
      yield put(addDepartmentFail(error.response?.data || error.message))
    }
  }
}

function* updateDepartmentSaga(action) {
  try {
    const { data } = yield call(updateDepartmentApi, action.payload)
    yield put(updateDepartmentSuccess(data))
    toast.success('Department updated successfully!')
    yield put({ type: GET_DEPARTMENTS })
  } catch (error) {
    if (error.response?.status === 400 && error.response?.data?.fieldErrors) {
      yield put(setDepartmentFieldErrors(error.response.data.fieldErrors))
    } else {
      yield put(updateDepartmentFail(error.response?.data || error.message))
    }
  }
}

function* deleteDepartmentSaga(action) {
  try {
    yield call(deleteDepartmentApi, action.payload)
    yield put(deleteDepartmentSuccess(action.payload))
    toast.success('Department deleted successfully!')
    yield put({ type: GET_DEPARTMENTS })
  } catch (error) {
    yield put(deleteDepartmentFail(error.response?.data || error.message))
  }
}

// Watcher saga
function* departmentSaga() {
  yield takeEvery(GET_DEPARTMENTS, getDepartmentsSaga)
  yield takeEvery(ADD_DEPARTMENTS, addDepartmentSaga)
  yield takeEvery(UPDATE_DEPARTMENTS, updateDepartmentSaga)
  yield takeEvery(DELETE_DEPARTMENTS, deleteDepartmentSaga)
}

export default departmentSaga
